import * as React from 'react';
import { useSelector } from 'react-redux';
import { selectUser } from 'gossamer-front-end';
import { EventList } from './WebsiteAccountLists';

export const WebsiteAccountUpcomingEventsPage = (): React.JSX.Element => {
  const user = useSelector(selectUser);
  return (
    <EventList
      query={{
        where: {
          and: [
            { fieldId: 'user_id', operator: 'eq', value: user?.userId || '' },
            { fieldId: 'start_at', operator: 'gt', value: new Date().toISOString() },
          ],
        },
        order: [['start_at', 'ASC']],
        offset: 0,
        limit: 50,
      }}
      emptyText="No upcoming events."
    />
  );
};
